import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { SESSION_TOKEN } from './auth.interceptor';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const zone = inject(NgZone);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // La pantalla proyectada lleva su propia sesion: su 401 lo resuelve ella (renueva o avisa)
      // y no debe cerrar la de las demas pestañas.
      if (req.context.get(SESSION_TOKEN) !== null) return throwError(() => error);
      // /auth/logout ya va de salida: su 401 no debe mandar al lockscreen.
      if (error.status === 401 && !req.url.includes('/auth/login') && !req.url.includes('/auth/logout')) {
        // Obtenemos los datos del token actual antes de borrarlo
        const decoded = authService.decodeToken();
        if (decoded) {
          const lockedUser = {
            email: decoded.email,
            username: decoded.username || decoded.email.split('@')[0]
          };
          // Guardar información del usuario para el lockscreen
          localStorage.setItem('locked_user', JSON.stringify(lockedUser));
        }
        
        // Limpiamos el token actual
        authService.logout(false); // false para no redirigir dentro de logout

        // Guardamos la URL actual para retornar despues del lockscreen si se desea
        const returnUrl = router.routerState.snapshot.url;
        // La adjuntamos al error para que el reporte de errores (GlobalErrorHandler)
        // use la pantalla real donde ocurrio el problema y no /lockscreen tras el redirect.
        (error as HttpErrorResponse & { originRoute?: string }).originRoute = returnUrl;

        // Si ya estamos en una pantalla de autenticacion no hay que volver a
        // redirigir: cada 401 nuevo metia la URL completa del lockscreen dentro
        // de returnUrl y la direccion crecia sin fin (ticket E91D31).
        const onAuthScreen =
          returnUrl.startsWith('/lockscreen') || returnUrl.startsWith('/login');
        if (!onAuthScreen) {
          zone.run(() => {
            router.navigate(['/lockscreen'], { queryParams: { returnUrl } });
          });
        }
      }
      return throwError(() => error);
    })
  );
};
